import moment from 'moment';

// Loads today's active events from events:all for the monitor2 sidebar and list
export default {
  data () {
    return {
      events: [],
      events_loaded: false,
      ts: this.$store.state.timestamp || moment().unix(),
      ts_interval: undefined
    }
  },
  methods: {
    filter_events () {
      var filters = {
        daterange: {
          start: moment().startOf('day').unix(),
          end: moment().endOf('day').unix()
        },
        states: ["active"]
      };
      this.events_channel.push("filter_reply", filters)
        .receive("ok", (msg) => {
          this.ts = this.$store.state.timestamp || moment().unix();
          this.events = msg.events || [];
          this.events_loaded = true;
          if (this.on_events_loaded) this.on_events_loaded();
        })
        .receive("error", () => {
          console.log("Event filter failed");
        })
        .receive("timeout", () => {
          console.log("Event filter timeout");
        });
    },
    connect_events () {
      this.events_channel = this.$cloudserver.channel("events:all", false);
      this.events_channel.on("init", () => this.filter_events());
      this.events_channel.on("event-update", () => this.filter_events());
      this.events_channel.join();
    }
  },
  mounted () {
    this.$store.dispatch("get_profile").then(() => {
      this.$nextTick(() => this.connect_events());
    }, () => {});
    this.ts_interval = setInterval(() => {
      this.ts = this.$store.state.timestamp || moment().unix();
    }, 10000);
  },
  beforeDestroy () {
    clearInterval(this.ts_interval);
  }
}
